export default "__VITE_ASSET__xXiAitHF__"